// extracted by mini-css-extract-plugin
export default {"relations__header":"lsf-relations__header","relations__title":"lsf-relations__title","relations__content":"lsf-relations__content"};
    if(module.hot) {
      // 1637785520590
      var cssReload = require("/Users/nicholasrq/Git/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  